import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import useStyles from "@hooks/useStyles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Header from "@components/Main/Shared/Header";
import Footer from "@components/Main/Shared/Footer";

const { LINK_HELP, LINK_HELP_CONTACT, BRAND_NAME } = process.env;

const Accessibility = () => {
	const classes = useStyles("Terms");

	return (
		<React.Fragment>
			<Header />

			<Box p={"16px 0px"} bgcolor={"#f8f9fa"}>
				<Container maxWidth={"lg"}>
					<Box
						p={{ xs: "24px", sm: "40px 80px 60px" }}
						style={{ boxShadow: "rgba(60, 64, 67, 0.15) 0px 1px 3px 1px" }}
						bgcolor={"#FFF"}
						borderRadius={10}
					>
						<Box lineHeight={1.6} className={classes.body}>
							<h1>
								<strong>Accessibility Statement</strong>
							</h1>
							<p>
								<span>
									Liaison, Inc. is committed to making our website's content
									accessible and user friendly to everyone. If you are having
									difficulty viewing or navigating the content on this website,
									or notice any content, feature, or functionality that you
									believe is not fully accessible to people with disabilities,
									please{" "}
									<a href={LINK_HELP_CONTACT}>
										<span>email us</span>
									</a>{" "}
									with “Disabled Access” in the subject line and provide a
									description of the specific feature you feel is not fully
									accessible or a suggestion for improvement. We take your
									feedback seriously and will consider it as we evaluate ways to
									accommodate all of our customers and our overall accessibility
									policies. Additionally, while we do not control such vendors,
									we strongly encourage vendors of third-party digital content
									to provide content that is accessible and user friendly.
								</span>
							</p>
							<p>
								<span>Last Updated: October 31, 2023</span>
							</p>
						</Box>
					</Box>
				</Container>
			</Box>

			<Footer />
		</React.Fragment>
	);
};

export default Accessibility;
export const loader = (route) =>
	loadable(() => import("./Accessibility.component"), { ssr: !!route.ssr });
